/**
 * Avatar initials from a display name — the app-wide convention: the first letter of each of the first
 * two whitespace-separated words ("Catalin Uta" → "CU"), falling back to the first two characters for a
 * single-word name. Mirrors MemberAvatar's formula so every avatar surface reads the same.
 */
export function initials(name: string | null | undefined): string {
  const n = (name ?? '').trim();
  if (!n) return '?';
  const parts = n.split(/\s+/).filter(Boolean);
  return (parts.length >= 2 ? parts[0][0] + parts[1][0] : n.slice(0, 2)).toUpperCase();
}
